// extracted by mini-css-extract-plugin
export default {"container":"companyShow_container__QfxMw","tableCard":"companyShow_tableCard__f5MJs","showCurrency":"companyShow_showCurrency__IZgLV"};